import { Component, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'wl-share-link-dialog',
  templateUrl: './share-link-dialog.component.html',
  styleUrls: ['./share-link-dialog.component.less'],
  standalone: false
})
export class ShareLinkDialogComponent implements OnInit {
  isLoading = false;
  linkText: string;
  show = false;

  constructor() {}

  ngOnInit(): void {}

  public open(linkCallback: () => Promise<string>) {
    this.show = true;
    this.isLoading = true;
    linkCallback()
      .then((link) => {
        this.linkText = link;
      })
      .finally(() => (this.isLoading = false));
  }

  close() {
    this.linkText = '';
    this.show = false;
  }
}
